'use client'

import { useEffect, useState } from 'react'

import Countdown from 'react-countdown'

function GridItemCountdownTimer({
  countdownDate,
  countdownLabel,
}: {
  countdownDate: number
  countdownLabel?: string
}) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null // Prevents server-side rendering issues
  }

  countdownLabel = countdownLabel || 'Time to respond'

  const countdownDateInMs = countdownDate * 1000 // Convert UNIX timestamp to milliseconds

  // Function to get the current time in milliseconds
  const dateNow = () => Math.floor(Date.now() / 1000) * 1000

  // Compare the countdown date with the current time
  if (!countdownDate || countdownDateInMs <= dateNow()) {
    return null
  }

  const classes = `
    @container/countdown-timer
    absolute
    inset-0
    z-10
    flex
    flex-col
    items-center
    justify-center
    gap-xxs
    bg-black/60
    p-s
    text-white
    pointer-events-none
  `
  return (
    <Countdown
      date={countdownDateInMs}
      now={dateNow}
      renderer={({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
          return <></> // Render nothing if the countdown is complete
        }

        return (
          <div className={classes}>
            {countdownLabel ? <span className="font-bold">{countdownLabel}: </span> : null}

            <div className="flex items-start gap-s">
              <span className="flex flex-col items-center">
                <span className="text-[length:--p-l-size] font-bold xs:text-[length:--p-size]">
                  {days}
                </span>
                <span className="text-[length:--p-xs-size]">Days</span>
              </span>

              <span className="flex flex-col items-center">
                <span className="text-[length:--p-l-size] font-bold xs:text-[length:--p-size]">
                  {hours}
                </span>
                <span className="text-[length:--p-xs-size]">Hours</span>
              </span>

              <span className="flex flex-col items-center">
                <span className="text-[length:--p-l-size] font-bold xs:text-[length:--p-size]">
                  {minutes}
                </span>
                <span className="text-[length:--p-xs-size]">Minutes</span>
              </span>

              <span className="hidden flex-col items-center @[230px]/countdown-timer:flex">
                <span className="text-[length:--p-l-size] font-bold xs:text-[length:--p-size]">
                  {seconds}
                </span>
                <span className="text-[length:--p-xs-size]">Seconds</span>
              </span>
            </div>
          </div>
        )
      }}
    />
  )
}

function BasicCountdownTimer({
  countdownDate,
  countdownLabel,
}: {
  countdownDate: number
  countdownLabel?: string
}) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null // Prevents server-side rendering issues
  }

  countdownLabel = countdownLabel || 'Time to respond'

  const countdownDateInMs = countdownDate * 1000 // Convert UNIX timestamp to milliseconds

  // Function to get the current time in milliseconds
  const dateNow = () => Math.floor(Date.now() / 1000) * 1000

  // Compare the countdown date with the current time
  if (!countdownDate || countdownDateInMs <= dateNow()) {
    return null
  }

  return (
    <Countdown
      date={countdownDateInMs}
      now={dateNow}
      renderer={({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
          return <></> // Render nothing if the countdown is complete
        }

        return (
          <div className="flex w-full flex-col gap-xxs @container/countdown-timer">
            {countdownLabel ? (
              <span className="font-bold text-fg-title">{countdownLabel}: </span>
            ) : null}

            <div className="flex w-full items-start gap-s">
              <span className="flex flex-col items-center">
                <span className="text-[length:--p-s-size] font-bold text-fg-title xs:text-[length:--p-size]">
                  {days}
                </span>
                <span className="text-[length:--p-xs-size]">Days</span>
              </span>

              <span className="flex flex-col items-center">
                <span className="text-[length:--p-s-size] font-bold text-fg-title xs:text-[length:--p-size]">
                  {hours}
                </span>
                <span className="text-[length:--p-xs-size]">Hours</span>
              </span>

              <span className="flex flex-col items-center">
                <span className="text-[length:--p-s-size] font-bold text-fg-title xs:text-[length:--p-size]">
                  {minutes}
                </span>
                <span className="text-[length:--p-xs-size]">Minutes</span>
              </span>

              <span className="hidden flex-col items-center @[230px]/countdown-timer:flex">
                <span className="text-[length:--p-s-size] font-bold text-fg-title xs:text-[length:--p-size]">
                  {seconds}
                </span>
                <span className="text-[length:--p-xs-size]">Seconds</span>
              </span>
            </div>
          </div>
        )
      }}
    />
  )
}

export { GridItemCountdownTimer, BasicCountdownTimer }
